import call from "../../../../service/http";
import firmbioConstants from "./firmbioConstants";

export default {
  state: {
    firmBio: [],
  },
  mutations: {
    SET_FIRM_BIO: (state, payload) => {
      state.firmBio = payload;
    },
  },
  getters: {
    firmBio: (state) => state.firmBio,
  },
  actions: {
    getFirmBio: ({ commit }) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("get", firmbioConstants.getfirmBio)
        .then((res) => {
          commit("SET_FIRM_BIO", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    saveFirmBio: ({ commit, dispatch }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", firmbioConstants.firmBio, data)
        .then(() => {
          dispatch("getFirmBio");
          dispatch("Auth/user", null, { root: true });
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateFirmBio: ({ commit, dispatch }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", firmbioConstants.update, data)
        .then(() => {
          dispatch("getFirmBio");
          dispatch("Auth/user", null, { root: true });
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
